export const SET_LIST_ATTACHMENTS = 'SET_LIST_ATTACHMENTS'
export const REMOVE_ATTACHMENT = 'REMOVE_ATTACHMENT'
export const IS_FETCHING = 'IS_FETCHING'
export const IS_UPLOADING = 'IS_UPLOADING'
export const IS_DOWNLOADING = 'IS_DOWNLOADING'
export const RESET_STATE = 'RESET_STATE'
